import localforage from 'localforage';
localforage.config({
    name    : 'bahr_names',
    version : 2.2,
});

export default localforage;


// WEBPACK FOOTER //
// ./src/js/localgorgeConfig.js